
import bugsnag from '@bugsnag/js';
import { Report } from '@bugsnag/core';

import { Constants } from './constants';

// Look at getting user data linked to issues.
const bugsnagClient = bugsnag({
  apiKey: '0e11e3cabd2afbe7c62bc99a5a078f41',
  appType: 'client_portal',
  notifyReleaseStages: [Constants.PROD, Constants.STAGE, Constants.DEV],
  releaseStage: Constants.getEnvironment()
});

export default bugsnagClient;



// WEBPACK FOOTER //
// ./src/bugsnag.ts